<template>
  <div>
    <b-table striped small fixed responsive="sm" caption-top :items="items" :fields="fields">
      <template slot="table-caption">{{log? log.id: 'INVALID LOG ID' }}</template>
      <template slot="value" slot-scope="data">
        <strong>{{data.item.value | beautify}}</strong>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'Log',
  props: {
    id: {
      type: String,
      required: true,
    },   
  },
  data: function() {
    return {
      log: null,
      fields: [
        {key: 'key'},
        {key: 'value'},
      ],
    }
  },
  created: function() {
    console.debug('created : ', this.id)
    if (!this.id) {
      console.error("id required")
      return
    }

    const logId = this.id.split('/').filter( s => !!s).pop() //get last element
    console.info('logId: ', logId)
    this.$bind('log', this.$firebase.firestore().collection('logs').doc(logId))
  },    
  computed: {
    items() {
      const logDetails = this.log ? Object.entries(this.log) : [['id', 'Not found']]
      return logDetails.filter(([key, value]) => {
        return key !== 'deviceId' && key !== 'uid';
      })
      .map(([key, value]) => {
        return {key: key, value: value}
      })
    },
  },
  updated: function() {
    this.$nextTick(() => {
      if (this.log) this.$emit('updated', this.log);
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
